<cp-auth-page-common>

  <div class="AuthPageControlsContainer"
    (keyup.enter)="onRestorePassword()">

    <div class="AuthPageControlsHeader">
      {{ 'DESIGN_B.FORGOT_PASSWORD.RESET_PASSWORD' | translate }}
    </div>

    <div class="AuthPageInfoTextContainer">
      {{ 'DESIGN_B.RESET_PASSWORD.INFO' | translate }}
    </div>

    <div class="AuthPageControlsLabel">
      {{ 'DESIGN_B.RESET_PASSWORD.NEW_PASSWORD' | translate }}
    </div>

    <div class="PasswordInputContainer"
      [popupOpen]="true"
      [ignoreClickOutside]="showPasswordInputErrors"
      (clickOutside)="onPasswordInputLostFocus()">
      <cp-form-input [form]="formGroup"
        [valueType]="ValueType.PASSWORD"
        [controlName]="PASSWORD">
      </cp-form-input>
    </div>

    @if (formGroup?.get(PASSWORD)?.value) {
      <div
        class="PasswordRequirementsContainer">
        <cp-password-requirements [form]="formGroup"
          [controlName]="PASSWORD"
          [showErrors]="showPasswordInputErrors">
        </cp-password-requirements>
      </div>
    }

    <hr>

      <div class="AuthPageControlsFooter">
        <span></span>
        <cp-button [size]="ButtonSize.MEDIUM"
          [disabled]="!formGroup?.valid || inProgress || isReferenceInvalid"
          [text]="'DESIGN_B.FORGOT_PASSWORD.SAVE_PASSWORD' | translate"
          [stopPropagation]="false"
          [showSpinner]="inProgress"
          (buttonClick)="onRestorePassword()">
        </cp-button>
      </div>

    </div>

    @if (showErrorMessage) {
      <div
        class="AuthPageAlertMessageContainer">
        <cp-message-design-b-small
          [(visible)]="showErrorMessage"
      [messageText]="
        ('DESIGN_B.USER_REGISTER.WRONG_LINK' | translate)
        + ' '
        + ('DESIGN_B.USER_REGISTER.LOGIN_REDIRECT_HINT' | translate)
      ">
        </cp-message-design-b-small>
      </div>
    }

  </cp-auth-page-common>
